<template>
    <b-modal 
        id="add-address" 
        title="Add Address"
        size="sm" 
        centered
    >
        <form >
            <b-row class="justify-content-between">
                <b-col >
                    <label for="imsi-input" class="font-weight-600">ICCID</label>
                    <b-input
                        id="imsi-input"
                        v-model="iccid"
                        type="number"
                        placeholder="Enter ICCID"
                        class="mb-3"
                        :state="iccidState"
                    >
                    </b-input>
                </b-col>
            </b-row>
            <b-row class="justify-content-between">
                <b-col>
                    <label for="imsi-input" class="font-weight-600">IMSI</label>
                    <b-input
                        id="imsi-input"
                        v-model="imsi"
                        type="number"
                        placeholder="Enter IMSI"
                        class="mb-3"
                        :state="imsiState"
                    >
                    </b-input>
                </b-col>
            </b-row>
            <b-row class="justify-content-between">
                <b-col>
                    <label for="msisdn-input" class="font-weight-600">MSISDN</label>
                    <b-input
                        id="msisdn-input"
                        v-model="msisdn"
                        type="number"
                        placeholder="Enter MSISDN"
                        class="mb-3"
                        :state="msisdnState"
                    >
                    </b-input>
                </b-col>
            </b-row>
            <b-row class="justify-content-between">
                <b-col>
                    <label for="address-1-input" class="font-weight-600">Street Address</label>
                    <b-input
                        id="address-1-input"
                        v-model="address.streetAddress"
                        type="text"
                        placeholder="ex. 123 Cherry Ln."
                        class="mb-3"
                        size="sm"
                        :state="address1State"
                    >
                    </b-input>
                </b-col>
            </b-row>
            <b-row class="justify-content-between">
                <b-col>
                    <label for="address-2-input" class="font-weight-600">Address Line 2</label>
                    <b-input
                        id="address-2-input"
                        v-model="address.streetAddress2"
                        type="text"
                        placeholder="ex. Apt. 2"
                        class="mb-3"
                        size="sm"
                        :state="address2State"
                    >
                    </b-input>
                </b-col>
            </b-row>
            <b-row class="justify-content-between">
                <b-col>
                    <label for="city-input" class="font-weight-600">City</label>
                    <b-input
                        id="city-input"
                        v-model="address.city"
                        type="text"
                        placeholder="ex. St. Louis"
                        class="mb-3"
                        size="sm"
                        :state="cityState"
                    >
                    </b-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col >
                    <label for="state-input" class="font-weight-600">State</label>
                    <b-form-select
                        id="state-input"
                        v-model="address.state"
                        :options="stateOptions"
                        class="mb-3"
                        size="sm"
                        :state="stateState"
                    >
                    </b-form-select>
                </b-col>
                <b-col cols="5">
                    <label for="zip-code-input" class="font-weight-600">Zip Code</label>
                    <b-input
                        id="zip-code-input"
                        v-model="address.zipCode"
                        type="number"
                        placeholder="ex. 52405"
                        class="mb-3"
                        size="sm"
                        :state="zipCodeState"
                    >
                    </b-input>
                </b-col>
            </b-row>
        </form>
        <template #modal-footer>
            <b-button class="float-right" variant="danger" @click="closeModal">
                Cancel
            </b-button>
            <b-button 
                class="float-right ml-3" 
                variant="primary" 
                type="submit" 
                :disabled="submitDisabled"
                @click="saveAddress"
            >
                <i v-if="loadingStatus" class="fas fa-spinner fa-spin"> </i>
                Save
            </b-button>
        </template>
    </b-modal>
</template>

<script>

import entitlementsService from "@/common/api-services/entitlements-dashboard-service";
import Toast from "../../Components/Toast.vue";

export default {
    name: 'AddAddressModal',
    components: {
        Toast,
    },
    data() {
        return {
            iccid: '',
            imsi: '',
            msisdn: '',
            address: {
                streetAddress: '',
                streetAddress2: '',
                city: '',
                state: null,
                zipCode: '',
            },
            loadingStatus: false,
            stateOptions: [
                {value: null, text: '- Select -'},
                {value: 'AL', text: 'Alabama'},
                {value: 'AK', text: 'Alaska'},
                {value: 'AZ', text: 'Arizona'},
                {value: 'AR', text: 'Arkansas'},
                {value: 'CA', text: 'California'},
                {value: 'CO', text: 'Colorado'},
                {value: 'CT', text: 'Connecticut'},
                {value: 'DE', text: 'Delaware'},
                {value: 'DC', text: 'District Of Columbia'},
                {value: 'FL', text: 'Florida'},
                {value: 'GA', text: 'Georgia'},
                {value: 'HI', text: 'Hawaii'},
                {value: 'ID', text: 'Idaho'},
                {value: 'IL', text: 'Illinois'},
                {value: 'IN', text: 'Indiana'},
                {value: 'IA', text: 'Iowa'},
                {value: 'KS', text: 'Kansas'},
                {value: 'KY', text: 'Kentucky'},
                {value: 'LA', text: 'Louisiana'},
                {value: 'ME', text: 'Maine'},
                {value: 'MD', text: 'Maryland'},
                {value: 'MA', text: 'Massachusetts'},
                {value: 'MI', text: 'Michigan'},
                {value: 'MN', text: 'Minnesota'},
                {value: 'MS', text: 'Mississippi'},
                {value: 'MO', text: 'Missouri'},
                {value: 'MT', text: 'Montana'},
                {value: 'NE', text: 'Nebraska'},
                {value: 'NV', text: 'Nevada'},
                {value: 'NH', text: 'New Hampshire'},
                {value: 'NJ', text: 'New Jersey'},
                {value: 'NM', text: 'New Mexico'},
                {value: 'NY', text: 'New York'},
                {value: 'NC', text: 'North Carolina'},
                {value: 'ND', text: 'North Dakota'},
                {value: 'OH', text: 'Ohio'},
                {value: 'OK', text: 'Oklahoma'},
                {value: 'OR', text: 'Oregon'},
                {value: 'PA', text: 'Pennsylvania'},
                {value: 'RI', text: 'Rhode Island'},
                {value: 'SC', text: 'South Carolina'},
                {value: 'SD', text: 'South Dakota'},
                {value: 'TN', text: 'Tennessee'},
                {value: 'TX', text: 'Texas'},
                {value: 'UT', text: 'Utah'},
                {value: 'VT', text: 'Vermont'},
                {value: 'VA', text: 'Virginia'},
                {value: 'WA', text: 'Washington'},
                {value: 'WV', text: 'West Virginia'},
                {value: 'WI', text: 'Wisconsin'},
                {value: 'WY', text: 'Wyoming'}
            ]
        };
    },
    methods: {
        async saveAddress() {
            this.loadingStatus = true
            let payload = {
                address1: this.address.streetAddress,
                address2: this.address.streetAddress2,
                city: this.address.city,
                state: this.address.state,
                zipCode: this.address.zipCode,
            };
            await entitlementsService.VerifyAddress(payload)
                .then(async (response) => {
                    // console.log(response);
                    if (response.status !== "VALIDATED") {
                        throw new Error(response.error_description);
                    } else {
                        payload = {
                            iccid: this.iccid,
                            imsi: this.imsi,
                            msisdn: this.msisdn,
                            address1: response.Address1,
                            address2: response.Address2,
                            city: response.City,
                            state: response.State,
                            zipcode: response.Zip5,
                        };
                        // console.log("VerifyAddress", structuredClone(payload));
                        await entitlementsService
                            .SaveAddress(payload)
                            .then((response) => {
                                // console.log(response);
                                this.$root.$emit("refresh-search", {imsi: this.imsi, msisdn: this.msisdn})
                                this.showToast("success", "Address saved successfully")
                            })
                            .catch((error) => {
                                console.error(error);
                                this.showToast("error", error);
                            })
                            .finally(() => {
                                this.loadingStatus = false;
                                this.closeModal();
                            });
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.showToast(error, "error");
                })
		},

        closeModal() {
            this.iccid = '';
            this.imsi = '';
            this.msisdn = '';
            this.address = {
                streetAddress: '',
                streetAddress2: '',
                city: '',
                state: null,
                zipCode: '',
            };
            this.$bvModal.hide('add-address');
        },

        showToast(type, message, subtitle, title) {
			switch (type) {
				case "error":
					this.$toast.error({
						component: Toast,
						props: {
							subtitle: subtitle,
							title: title,
							description: message,
						}, 
						duration: 4000
					});
				break;
				case "success":
					this.$toast.success({
						component: Toast,
						props: {
							subtitle: subtitle,
							title: title,
							description: message,
						}, 
						duration: 4000
					});
				break;
				case "warning":
					this.$toast.warning({
						component: Toast,
						props: {
							subtitle: subtitle,
							title: title,
							description: message,
						}, 
						duration: 4000
					});
				break;
				default:
					this.$toast({
						component: Toast,
						props: {
							subtitle: subtitle,
							title: title,
							description: message,
						}, 
						duration: 4000
					})
			}
		},
    },
    computed: {
        submitDisabled() {
            if (this.loadingStatus) {
                return true
            }
            return this.iccidState && this.imsiState && this.msisdnState && (this.address1State || this.address2State) && this.cityState && this.stateState && this.zipCodeState ? false : true;
        },
        iccidState() {
            return this.iccid.length === 20 ? true : false;
        },
        imsiState() {
            return this.imsi.length === 15 ? true : false;
        },
        msisdnState() {
            return this.msisdn.length === 11 ? true : false;
        },
        address1State() {
            if (this.address.streetAddress.length === 0 && this.address.streetAddress2.length > 0) {
                return null;
            }
            return this.address.streetAddress.length > 0 ? true : false;
        },
        address2State() {
            if (this.address.streetAddress2.length === 0 && this.address.streetAddress.length > 0) {
                return null;
            }
            return this.address.streetAddress2.length > 0 ? true : false;
        },
        cityState() {
            return this.address.city.length > 0 ? true : false;
        },
        stateState() {
            return this.address.state != null ? true : false;
        },
        zipCodeState() {
            return this.address.zipCode.length === 5 ? true : false;
        },
    },
    // Your lifecycle hooks go here
};
</script>

